import { render, staticRenderFns } from "./device-info.vue?vue&type=template&id=298508f8&scoped=true&"
import script from "./device-info.vue?vue&type=script&lang=js&"
export * from "./device-info.vue?vue&type=script&lang=js&"
import style0 from "./device-info.vue?vue&type=style&index=0&id=298508f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298508f8",
  null
  
)

export default component.exports